import React, { FC } from 'react'
import { useRouteMatch } from 'react-router-dom'
import ROUTES from '../../utils/routes'
import { StyledFooter } from '.'

const Footer: FC = () => {
  const isCommunity = useRouteMatch(ROUTES.dashboard.community)?.isExact

  if (isCommunity) {
    return <></>
  }

  return (
    <StyledFooter>
      <div className="footer-links">
        <a href={ROUTES.external.aboutJasmineUrl} target="_blank" rel="noopener noreferrer">
          About
        </a>
        <a href={ROUTES.external.helpCenterUrl} target="_blank" rel="noopener noreferrer">
          Resource Center
        </a>
        <a href={ROUTES.external.usageAgreementUrl} target="_blank" rel="noopener noreferrer">
          User Agreement
        </a>
        <a href={ROUTES.external.termsOfServiceUrl} target="_blank" rel="noopener noreferrer">
          Terms
        </a>
        <a href={ROUTES.external.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </div>
    </StyledFooter>
  )
}

export default Footer
